import { render, staticRenderFns } from "./CreerVin.vue?vue&type=template&id=267d4867&"
import script from "./CreerVin.vue?vue&type=script&lang=js&"
export * from "./CreerVin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PROJETS\\VITISSIA\\2024\\vitissiapro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('267d4867')) {
      api.createRecord('267d4867', component.options)
    } else {
      api.reload('267d4867', component.options)
    }
    module.hot.accept("./CreerVin.vue?vue&type=template&id=267d4867&", function () {
      api.rerender('267d4867', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/CreerVin.vue"
export default component.exports